var MobileNav = function() {
  var $ = require('jquery');
  var $menu = $('.mobile-menu');
  var $wrap = $menu.find('.mobile-menu__container');
  var $back = $menu.find('.js-back');
  var $current = null;
  var level = 0;

  $(".js-mobile-trigger").click(function(){
    $(".l-header__nav-trigger").toggleClass("active");
    $(".mobile-menu").toggleClass("active");
  });

  $back.click(function(e) {
    level--;
    $wrap.animate({
      left: '+=100%'
    }, function() {
      if(level === 0) {
        $wrap.find('ul').hide();
      } else {
        if($current) $current.hide();
        $current = (level < 1 && $current) ? $current.parents('ul') : null;
      }
    });
  });

  $menu.find('li').not('.js-back').click(function(e) {
    e.stopPropagation();
    var $target = $(e.target);
    if($target.is('.js-back') || $target.parents('.js-back').length || $target.is('a')) return;
    level++;

    var $this = $(this);
    if(!$this.find('> ul').length) return;

    $current = $this.find('> ul');
    $current.show();

    $wrap.animate({
      left: '-=100%'
    });
  });
}
module.exports = MobileNav;